import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function AddTemplateDialogButton({
  onSave,
}: {
  onSave?: (name: string) => void
}) {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-test-id="add-template-button" className="bg-toast-deep text-forest hover:bg-toast-deep/90">
          {t('templates.addTemplate')}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl">
        <form
          onSubmit={(e) => {
            e.preventDefault()

            const form = e.target as HTMLFormElement
            const data = new FormData(form)
            const name = data.get('name') as string

            if (name.trim() === '') return

            onSave?.(name)
            setOpen(false)
          }}
        >
          <DialogHeader>
            <DialogTitle>{t('templates.addTemplate')}</DialogTitle>
            <DialogDescription>
              {t('templates.addTemplateDescription')}
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="name" className="text-right">
                {t('templates.templateName')}
              </Label>
              <Input
                id="name"
                name="name"
                data-test-id="add-template-name"
                className="col-span-3"
                autoComplete="off"
                data-1p-ignore
              />
            </div>
          </div>
          <DialogFooter className="!justify-between">
            <Button
              variant="secondary"
              type="button"
              onClick={() => setOpen(false)}
            >
              {t('cancel')}
            </Button>
            <Button data-test-id="add-template-submit" type="submit" className="bg-toast-deep text-forest hover:bg-toast-deep/90">
              {t('templates.createTemplate')}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
